import React from 'react';
import { Card, Row, Col, Typography, Avatar, Space } from 'antd';
import { 
  TeamOutlined, 
  CrownOutlined, 
  BookOutlined, 
  ToolOutlined, 
  CustomerServiceOutlined,
  RocketOutlined
} from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const Team = () => {
  const teamSections = [
    {
      title: 'Nos Fondateurs',
      icon: <CrownOutlined style={{ color: '#faad14' }} />,
      description: 'D\'anciens consultants et gestionnaires dans des multinationales, qui ont fondé Nomidya avec la mission de partager leurs connaissances et expériences avec le monde. Leur passion pour l\'éducation et leur engagement envers nos apprenants sont au cœur de notre succès.',
      color: '#faad14',
      bgColor: '#fffbe6'
    },
    {
      title: 'Nos Formateurs',
      icon: <BookOutlined style={{ color: '#52c41a' }} />,
      description: 'Soigneusement sélectionnés, sont des experts du secteur, dotés d\'une vaste expérience pratique et d\'une connaissance approfondie des sujets qu\'ils enseignent. Ils sont déterminés à aider nos apprenants à acquérir des compétences de niveau supérieur et à les préparer à relever les défis du monde professionnel.',
      color: '#52c41a',
      bgColor: '#f6ffed'
    },
    {
      title: 'Notre Équipe Technique',
      icon: <ToolOutlined style={{ color: '#1890ff' }} />,
      description: 'Travaille sans relâche pour maintenir notre plateforme éducative à la pointe de la technologie. Ils s\'efforcent d\'intégrer les dernières innovations et les meilleures pratiques pédagogiques pour offrir une expérience d\'apprentissage fluide et enrichissante.',
      color: '#1890ff',
      bgColor: '#e6f7ff'
    },
    {
      title: 'Notre Support Apprenants',
      icon: <CustomerServiceOutlined style={{ color: '#f5222d' }} />,
      description: 'Est là pour guider, accompagner et répondre aux questions de nos apprenants à chaque étape de leur parcours d\'apprentissage. Ils s\'assurent que nos apprenants reçoivent un soutien personnalisé et des réponses rapides à leurs besoins.',
      color: '#f5222d',
      bgColor: '#fff1f0'
    }
  ];

  return (
    <div className="team-page" style={{ padding: '20px 0' }}>
      <div className="container">
        <Card className="mb-4" style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
          {/* En-tête */}
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <Title level={1} style={{ color: '#1890ff' }}>
              <TeamOutlined /> Rencontrez l'équipe de Nomidya !
            </Title>
            <Paragraph style={{ fontSize: '18px', color: '#666', maxWidth: '800px', margin: '0 auto' }}>
              Nous sommes une équipe passionnée de professionnels dévoués, animés par une vision commune : offrir une expérience d'apprentissage en ligne exceptionnelle à nos apprenants du monde entier.
            </Paragraph>
          </div>

          {/* Introduction générale */}
          <Card style={{ marginBottom: '30px', background: '#f0f2f5' }}>
            <Paragraph style={{ fontSize: '16px', lineHeight: '1.8', textAlign: 'justify', margin: 0 }}>
              Notre équipe est composée d'experts chevronnés dans les domaines de SAP, de la gestion de projets, de la formation professionnelle et de la technologie, chacun apportant son expertise unique pour enrichir notre plateforme éducative.
            </Paragraph>
          </Card>

          {/* Sections de l'équipe */}
          <Row gutter={[24, 24]}>
            {teamSections.map((section, index) => (
              <Col xs={24} md={12} key={index}>
                <Card 
                  hoverable
                  style={{ 
                    height: '100%',
                    borderLeft: `5px solid ${section.color}`,
                    background: section.bgColor
                  }}
                  bodyStyle={{ padding: '30px' }}
                >
                  <Space direction="vertical" size="large" style={{ width: '100%' }}>
                    <div style={{ textAlign: 'center' }}>
                      <Avatar 
                        size={64} 
                        style={{ backgroundColor: section.color, marginBottom: '16px' }}
                        icon={section.icon}
                      />
                      <Title level={3} style={{ color: section.color, margin: 0 }}>
                        {section.title}
                      </Title>
                    </div>
                    <Paragraph style={{ 
                      fontSize: '15px', 
                      lineHeight: '1.7', 
                      textAlign: 'justify',
                      margin: 0,
                      color: '#333'
                    }}>
                      {section.description}
                    </Paragraph>
                  </Space>
                </Card>
              </Col>
            ))}
          </Row>

          {/* Message de conclusion */}
          <Card style={{ 
            marginTop: '40px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white'
          }}>
            <div style={{ textAlign: 'center' }}>
              <Title level={2} style={{ color: 'white', marginBottom: '20px' }}>
                <RocketOutlined /> Une Équipe Unie
              </Title>
              <Paragraph style={{ 
                fontSize: '16px', 
                lineHeight: '1.8', 
                color: 'white',
                marginBottom: '16px'
              }}>
                Chez Nomidya, nous sommes une équipe unie par la passion de l'éducation et la volonté de faire une différence dans la vie de nos apprenants. Ensemble, nous formons une communauté dynamique, ouverte et engagée à aider chaque apprenant à atteindre ses objectifs professionnels.
              </Paragraph>
              <Paragraph style={{ 
                fontSize: '18px', 
                fontWeight: 'bold',
                color: '#ffd700',
                margin: 0
              }}>
                Rejoignez-nous pour faire partie de cette aventure passionnante de développement et de croissance professionnelle. L'équipe de Nomidya est là pour vous soutenir dans votre quête de connaissances et de réussite professionnelle.
              </Paragraph>
            </div>
          </Card>

          {/* Call to action final */}
          <Card style={{ 
            marginTop: '20px', 
            textAlign: 'center',
            background: '#f0f2f5',
            border: '2px dashed #1890ff'
          }}>
            <Title level={4} style={{ color: '#1890ff', marginBottom: '10px' }}>
              Ensemble, nous construisons un avenir
            </Title>
            <Paragraph style={{ 
              fontSize: '16px', 
              margin: 0,
              color: '#666'
            }}>
              où l'apprentissage transforme des vies et où les compétences ouvrent des portes vers de nouvelles opportunités.
            </Paragraph>
          </Card>
        </Card>
      </div>
    </div>
  );
};

export default Team;